import { createStore, combineReducers,  applyMiddleware, compose } from "redux";

import thunk from 'redux-thunk';
import { authReducer } from "../reducers/authReducer";
import { uiReducers } from "../reducers/uiReducers";
import { aplicationReducer } from "../reducers/aplicationReducer";


const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;


const reducers = combineReducers({
    auth: authReducer,
    ui: uiReducers,
    titleandvideo: aplicationReducer,
});


export const store = createStore(
     reducers,
     composeEnhancers(
        applyMiddleware(thunk)
     )
     
);